
import { Component, Vue, } from 'vue-property-decorator';
import { validationMixin, } from 'vuelidate';
import { required, } from 'vuelidate/lib/validators';
import { Store, } from '~/apps/account/store';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import Checklist from '~/components/self-serve/checklist/checklist.vue';
import LandingSection from '~/components/self-serve/landing-section/landing-section.vue';
import Tooltip from '~/components/tooltip/tooltip.vue';
import { CHECKLIST_ITEMS, } from '~/utils/self-serve-checklist-items';

const ChecklistItems = [
	'customerNumber',
	CHECKLIST_ITEMS.lastNameOnBill,
	CHECKLIST_ITEMS.emailAddress,
];

@Component({
	components: {
		FeedbackBox,
		HeaderText,
		LandingLink,
		LandingSection,
		Checklist,
		Tooltip,
	},
	mixins: [validationMixin,],
	validations: {
		agreeTnc: {
			required,
		},
	},
})
export default class RegisterLandingPage extends Vue {
	accept = false;
	apiError: string | null = null;
	agreeTnc = false;

	registrationContent = Store.state.customContent.registrationContent;

	mounted() {
		Store.commit.register.reset();
		Store.commit.register.setStep(null);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	checkboxToggle(event: any) {
		this.accept = event.target.checked;
	}

	privacyLink = Store.getters.getGlobalConfigValue('PrivacyLink');

	handleSubmit() {
		const currentForm = this.$v;
		currentForm.$touch();
		window.scrollTo(0, 0);
		if (!currentForm.agreeTnc.$model) {
			return;
		}
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		return this.$router.push('/digital-billing/your-details').catch(() => { });
	}

	checklistItems = ChecklistItems;
	customerNumber = CHECKLIST_ITEMS.customerNumber;

	focusRef(ref: string) {
		(this.$refs[ref] as HTMLElement)?.focus();
	}
}
